<template>
	<div
		class="vx-row center-content"
		style="justify-content: center; position: relative"
	>
		<div @click.stop="displayMccIdPopup()" v-if="$props.type_id == 2">
			<vx-tooltip
				:text="$props.google_ads_mcc ? getGoogleAdsCost() : 'Ajouter MCC Id'"
				position="top"
				style="text-align: -webkit-center; margin-right: 0 !important"
			>
				<img
					v-if="$props.google_ads_mcc"
					src="@/assets/icons/adswords.png"
					alt="graphic-404"
					style="width: 16px; height: 16px"
				/>
				<vs-icon
					v-else
					icon="warning"
					size="small"
					class="cursor-pointer"
					color="warning"
				/>
			</vx-tooltip>
		</div>
		<div v-else></div>
	</div>
</template>
  
  <script>
import Vue from "vue";
import AddMccIdPopup from "../popups/AddMccIdPopup.vue";
import moment from "moment";
// import store from "@/store/store";

export default {
	name: "GoogleAdsCostViewChip",
	props: {
		type_id: {
			type: Number,
			default: 1,
			required: true,
		},
		google_ads_mcc: {
			type: String,
			default: 1,
			required: true,
		},
		additonalText: {
			type: String,
			default: "",
		},
		googleAds: {
			type: Array,
			default: {},
			required: true,
		},
		societyId: {
			type: Number,
			default: 0,
			required: true,
		},
		date: {
			type: Date,
			default: 0,
			required: true,
		},
		limit: {
			type: Number,
			default: 1,
		},
	},
	components: {},
	data() {
		return {
			showMccIdPopup: false,
		};
	},
	beforeUnmount() {
		// Find and remove any lingering tooltip elements
		const tooltips = document.querySelectorAll(".vx-tooltip-content");
		tooltips.forEach((tooltip) => tooltip.remove());
	},

	computed: {},

	methods: {
		getGoogleAdsCost() {
			if (this.$props.date) {
				return this.getGoogleAdsCostByPeriod();
			} else {
				return this.getGoogleAdsTotalCost();
			}
		},
		/**
		 * Get google ads total cost
		 * @param societyId
		 * @param period
		 */
		getGoogleAdsTotalCost() {
			if (!this.isLoadingGoogleAds) {
				// debugger;
				const thisSoc = this.$props.googleAds.find((ads) => {
					return ads.societyId == this.$props.societyId;
				});
				if (thisSoc.status == 200) {
					if (thisSoc.google_ads && thisSoc.google_ads.totalCost) {
						return thisSoc.google_ads.totalCost.toLocaleString("fr-FR", {
							style: "currency",
							currency: thisSoc.google_ads.currency,
						});
					} else return "null";
				} else {
					return "Vérifier le MCC ID ou Service non disponible";
				}
			}
		},
		/**
		 * Get google ads cost by period
		 * @param societyId
		 * @param period
		 */
		getGoogleAdsCostByPeriod() {
			if (!this.isLoadingGoogleAds) {
				const thisSoc = this.$props.googleAds.find((ads) => {
					return ads.societyId == this.$props.societyId;
				});
				let text = "";
				for (let i = 0; i < this.limit; i++) {
					let addText = i == 0 ? this.additonalText : "";
					const period = moment(this.$props.date)
						.subtract(i, "months")
						.format("MM/YYYY");
					const periodName =
						moment(this.$props.date)
							.subtract(i, "months")
							.format("MMMM YYYY")
							.charAt(0)
							.toUpperCase() +
						moment(this.$props.date)
							.subtract(i, "months")
							.format("MMMM YYYY")
							.slice(1);
					if (thisSoc.status == 200) {
						if (thisSoc.google_ads) {
							if (thisSoc.google_ads.campaigns[`${period}`]) {
								text +=
									periodName +
									" : " +
									thisSoc.google_ads.campaigns[`${period}`].toLocaleString(
										"fr-FR",
										{
											style: "currency",
											currency: thisSoc.google_ads.currency,
										}
									) +
									addText +
									"\n";
							} else text += "-\n";
						}
					} else {
						text = "Vérifier le MCC ID ou Service non disponible";
					}
				}
				return text;
				// const period = moment(this.$props.date).format("MM/YYYY");
				// const periodName =
				// 	moment(this.$props.date).format("MMMM YYYY").charAt(0).toUpperCase() +
				// 	moment(this.$props.date).format("MMMM YYYY").slice(1);
				// if (thisSoc.status == 200) {
				// 	if (thisSoc.google_ads) {
				// 		if (thisSoc.google_ads.campaigns[`${period}`]) {
				// 			return (
				// 				periodName +
				// 				" : " +
				// 				thisSoc.google_ads.campaigns[`${period}`].toLocaleString(
				// 					"fr-FR",
				// 					{
				// 						style: "currency",
				// 						currency: "EUR",
				// 					}
				// 				) +
				// 				this.$props.additonalText
				// 			);
				// 		} else return "-";
				// 	} else return null;
				// } else {
				// 	return "Vérifier le MCC ID ou Service non disponible";
				// }
			}
		},
		displayMccIdPopup() {
			// Initialisation des données pour le popup
			this.showMccIdPopup = true;
			// Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(AddMccIdPopup);
			let mccIdPopup = new ComponentClass({
				propsData: {
					popupActive: this.showMccIdPopup,
					router: this.$router,
					apiUrl: this.apiUrl,
					societyId: this.$props.societyId,
					mccId: this.$props.google_ads_mcc,
				},
			});
			mccIdPopup.$mount();
			this.$refs.popupContainer.appendChild(mccIdPopup.$el);
			mccIdPopup.$on("close-popup", (data) => {
				this.showMccIdPopup = false;
			});
		},
	},
};
</script>
  
  <style scoped>
</style>
  